const articleCarousel = {
  displayField: 'shopId',
  name: 'Article Carousel',
  description: 'Sets Shop ID for Article Carousel to display latest 3 articles for a given shop (or tag).',
  fields: [
    {
      id: 'altHeader',
      name: 'Alt Header',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'shopId',
      name: 'Shop ID',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaText',
      name: 'Cta Text',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaUrl',
      name: 'Cta URL',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'articleCarousel',
    version: 12,
    updatedAt: '2023-08-02T21:16:43.919Z'
  }
};
export default articleCarousel;